import { flowIdCyclingVlaanderenOfferFlowId } from '../../../../flows/src/constants/flowIds';
import useFlowsInitNew from '../../../../flows/src/hooks/init/useFlowsInitNew';
import useFlowsResetState from '../../../../flows/src/hooks/useFlowsResetState';

const useStartCyclingVlaanderenOfferFlow = (): ((
  uuid: string,
) => Promise<void>) => {
  const { initFlow } = useFlowsInitNew();
  const { reset } = useFlowsResetState();

  return async (uuid?: string) => {
    reset();

    await initFlow({
      flowId: flowIdCyclingVlaanderenOfferFlowId,
      payload: {},
      outputUrl: `/sales-conversation/offers/overview/bicycle`,
      sessionId: uuid,
    });
  };
};

export default useStartCyclingVlaanderenOfferFlow;
